export const ALPHA = 'ALPHA';
export const BETA = 'BETA';
export const PRODUCTION = 'PRODUCTION';
export const PREVIEW = 'PREVIEW';

export const environmentSwitchOptions = [
  { value: PREVIEW, label: 'Preview / Staging (Default)', icon: 'eye-fill' },
  { value: PRODUCTION, label: 'Production / Live', icon: 'paper-plane' },
  { value: BETA, label: 'Sandbox', icon: 'type-bold' },
  { value: ALPHA, label: 'UAT', icon: 'font' },
];

export const environmentPublishSwitchOptions = [
  { value: PRODUCTION, label: 'Production / Live Data', icon: 'paper-plane' },
  { value: BETA, label: 'Sandbox', icon: 'type-bold' },
  { value: ALPHA, label: 'UAT', icon: 'font' },
];

export const generateUrl = (version, projectDetail, envType) => {
  const { seoName } = projectDetail;
  let url = '';
  const {
    REACT_APP_EXCHANGE_ENGINE,
    REACT_APP_EXCHANGE_ENGINE_PREVIEW,
    REACT_APP_EXCHANGE_ENGINE_ALPHA,
    REACT_APP_EXCHANGE_ENGINE_BETA,
  } = process.env;

  if (envType === ALPHA) {
    url = `${seoName}.${REACT_APP_EXCHANGE_ENGINE_ALPHA}`;
  } else if (envType === BETA) {
    url = `${seoName}.${REACT_APP_EXCHANGE_ENGINE_BETA}`;
  } else if (envType === PREVIEW) {
    url = `${seoName}.${REACT_APP_EXCHANGE_ENGINE_PREVIEW}`;
  } else if (envType === PRODUCTION) {
    url = `${seoName}.${REACT_APP_EXCHANGE_ENGINE}`;
  }
  let protocol = `https`;
  const APP_ENV = process.env.REACT_APP_ENVIRONMENT;
  if (APP_ENV && APP_ENV.toLowerCase().trim().startsWith('dev')) {
    protocol = `http`;
  }
  return `${protocol}://${url}api/v1/`;
};

export const generateSurfaceUrl = (envType, seoName) => {
  const { REACT_APP_EXCHANGE_SURFACE, REACT_APP_ENVIRONMENT } = process.env;
  let url = '';
  let protocol = `https`;
  if (REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT.toLowerCase().trim().startsWith('dev')) {
    protocol = `http`;
  }
  if (envType === ALPHA) {
    url = `${protocol}://${seoName}.uat.${REACT_APP_EXCHANGE_SURFACE}`;
  } else if (envType === BETA) {
    url = `${protocol}://${seoName}.sandbox.${REACT_APP_EXCHANGE_SURFACE}`;
  } else if (envType === PRODUCTION) {
    url = `${protocol}://${seoName}.${REACT_APP_EXCHANGE_SURFACE}`;
  } else if (envType === PREVIEW) {
    url = `${protocol}://${seoName}.preview.${REACT_APP_EXCHANGE_SURFACE}`;
  }
  return url;
};

export const constructDeveloperApiDocsUrl = (apiDomainName) => {
  let apiUrl = '';
  const APP_ENV = process.env.REACT_APP_ENVIRONMENT || 'DEVELOPMENT';
  if (APP_ENV && APP_ENV.toLowerCase().trim().startsWith('dev')) {
    const port = process.env.REACT_APP_EXCHANGE_ENGINE_PORT || '6002';
    apiUrl = `http://${apiDomainName}:${port}/api/v1/docs`;
  } else {
    apiUrl = `https://${apiDomainName}/api/v1/docs`;
  }
  return apiUrl;
};

export const getProtocolForCustomDomains = (projectDetail) => {
  const { REACT_APP_ENVIRONMENT } = process.env;
  const { projectType } = projectDetail;
  const isFreeProject = !projectType || projectType == 'FREE';
  let protocol = `https`;
  if (REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT.toLowerCase().trim().startsWith('dev')) {
    protocol = `http`;
  }
  return { protocol, isFreeProject };
};
